var _stop, _stop2, _stop3, _stop4, _stop5, _stop6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgQuestion(props) {
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.17 1.75c-4.638 0-8.385 3.754-8.385 8.4l.003.213a8.589 8.589 0 001.511 4.61l.01.011.003.026-1.541 3.64 3.67-1.56-.085-.057c1.453 1.001 3.066 1.517 4.813 1.517 4.638 0 8.384-3.753 8.384-8.4 0-4.646-3.746-8.4-8.384-8.4zm0 .8c4.195 0 7.583 3.396 7.583 7.6 0 4.205-3.388 7.6-7.584 7.6l-.215-.002a7.504 7.504 0 01-3.963-1.252l-.088-.06-.011-.017a.478.478 0 00-.236-.17.643.643 0 00-.243-.03l-.056.006a.517.517 0 00-.32.159l-.011.014-1.747.742.835-1.972v-.081a1.3 1.3 0 00-.016-.236l-.015-.073a.67.67 0 00-.121-.258l-.011-.012.008.012a7.773 7.773 0 01-1.374-4.37c0-4.204 3.389-7.6 7.584-7.6z",
    fill: "url(#".concat(_id, ")"),
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.183 12.799c-.17 0-.34-.17-.34-.34v-1.954c0-.17.17-.34.34-.34 1.017 0 1.865-.85 1.865-1.869 0-1.02-.848-1.869-1.865-1.869-1.018 0-1.865.85-1.865 1.87 0 .169-.17.339-.34.339s-.339-.17-.339-.34a2.644 2.644 0 012.629-2.633 2.644 2.644 0 012.628 2.633c0 1.274-.933 2.379-2.205 2.549v1.614c-.17.17-.339.34-.508.34z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#".concat(_id3, ")"),
    cx: 10.25,
    cy: 14.25,
    r: 1
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.841%",
    y1: "7.565%",
    x2: "22.981%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.568%",
    y1: "7.565%",
    x2: "35.133%",
    y2: "87.141%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "7.565%",
    x2: "22.6%",
    y2: "87.141%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  })))));
}
export default SvgQuestion;